import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesDashboardComponent } from '@sales/components/dashboard';

const salesDashboardModuleRoutes: Routes = [
  { path: '', component: SalesDashboardComponent, data: { title: 'Sales Dashboard' } }
];
@NgModule({
  imports: [
    RouterModule.forChild(salesDashboardModuleRoutes),
  ]
})
export class SalesDashboardModule { }
